import React from 'react';
import styled from 'styled-components';
export const Heading = styled.h3 `
  margin: 0;
  font-size: 14px;
`;
export const Description = styled.p `
  color: ${({ theme }) => theme.greys.raven};
  font-size: 12px;
`;
export const ChartHeading = (props) => {
    return (React.createElement(React.Fragment, null,
        props.heading && React.createElement(Heading, null, props.heading),
        props.subHeading && React.createElement(Description, null, props.subHeading)));
};
